export default __webpack_public_path__ + "static/media/04_DAIF_Infra_03_09_PowerScaleOneFS_loop.1a695675.mp4";